export default __webpack_public_path__ + "static/media/openness2Img2.6f41d704.png";